const FLOW_PAYLOAD_KEY = "ael.anmelden.flow.payload";
const FLOW_PAYLOAD_MAX_AGE_MS = 30 * 60 * 1000;

export function saveAnmeldenFlowPayload(payload) {
  if (typeof window === "undefined") return;

  try {
    const wrappedPayload = {
      savedAt: Date.now(),
      payload,
    };

    window.sessionStorage.setItem(
      FLOW_PAYLOAD_KEY,
      JSON.stringify(wrappedPayload),
    );
  } catch (error) {
    console.error("Could not save anmelden flow payload", error);
  }
}

export function readAnmeldenFlowPayload() {
  if (typeof window === "undefined") return null;

  try {
    const rawPayload = window.sessionStorage.getItem(FLOW_PAYLOAD_KEY);
    if (!rawPayload) return null;

    const parsed = JSON.parse(rawPayload);
    if (!parsed || typeof parsed !== "object") return null;

    const { savedAt, payload } = parsed;
    if (!savedAt || typeof savedAt !== "number") return null;

    if (Date.now() - savedAt > FLOW_PAYLOAD_MAX_AGE_MS) {
      window.sessionStorage.removeItem(FLOW_PAYLOAD_KEY);
      return null;
    }

    return payload ?? null;
  } catch (error) {
    console.error("Could not read anmelden flow payload", error);
    return null;
  }
}

export function clearAnmeldenFlowPayload() {
  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.removeItem(FLOW_PAYLOAD_KEY);
  } catch (error) {
    console.error("Could not clear anmelden flow payload", error);
  }
}
